import { render, staticRenderFns } from "./AddressesTable.vue?vue&type=template&id=f97b0d7c&scoped=true"
import script from "./AddressesTable.vue?vue&type=script&lang=ts"
export * from "./AddressesTable.vue?vue&type=script&lang=ts"
import style0 from "./AddressesTable.scss?vue&type=style&index=0&id=f97b0d7c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97b0d7c",
  null
  
)

export default component.exports